var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:`v-td td-${_vm.type}`,style:({
    width: _vm.tdWidth,
    maxWidth: _vm.tdWidth,
    padding: _vm.tdPadding,
    textAlign: _vm.align,
    whiteSpace: _vm.whiteSpace,
  }),attrs:{"title":_vm.title ? _vm.title : _vm.defualtTitle},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.type === 'content')?_c('div',{staticClass:"flex-center"},[_vm._t("default")],2):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }